/**
 * Copyright (c) Miihe, Inc. and its affiliates.
 * Date:2021/1/17
 * Power By ZhangHebo
 */
import Vue from 'vue'
let self = new Vue();

export default {
	getBar(data,name,color,width,labelPos='top'){
		if(color === 'green'){
			return this.getGreenBar(data,name,width,labelPos);
		}else if(color === 'blue'){
			return this.getBlueBar(data,name,width,labelPos);
		}else if(color === 'red'){
			return this.getRedBar(data,name,width,labelPos);
		}else if(color === 'most'){
			return this.getColorBar(data,name,width,labelPos);
		}
	},
	getColorBar(data,name,width,labelPos='top'){
		let _colors = ['#7ED321','#5C87F6','#FBC531','#E74218','#02C5C6','#9980F9'];

		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000'
			},
			barMaxWidth:width
		};

		if(data.length > 0){
			for(let i=0; i < data.length;i++){
				_bar.data.push({
					value: data[i],
					itemStyle: {
						color: _colors[i % _colors.length]
					}
				})
			}
		}
		return _bar;
	},
	getRedBar(data,name,width,labelPos = 'top',stack = ''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			stack:stack,
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#ff8080'
			}, {
				offset: 1,
				color: '#ff3535'
			}]),
			barMaxWidth:width
		};
		
		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getGreenBar(data,name,width,labelPos = 'top',stack = ''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			stack:stack,
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#7ED321'
			}, {
				offset: 1,
				color: '#1fab80'
			}]),
			barMaxWidth:width
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getBlueBar(data,name,width,labelPos = 'top',stack = ''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			stack:stack,
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#00CCEF'
			}, {
				offset: 1,
				color: '#009DD9'
			}]),
			barMaxWidth:width
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getNormalBar(data,name,width,labelPos = 'top',stack = ''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			stack:'total',
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000'
			},
			barMaxWidth:width
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getPurpleLine(data,name){
		let _line = {
			name: name,
			type: 'line',
			yAxisIndex: 1,
			data: [],
			color:'#651593',
			label: {
				show: true,
				position: 'top',
				formatter:'{c}%',
				color:'#000'
			},
		};

		if(data.length > 0){
			_line.data = data;
		}
		return _line;
	},
	getRedLine(data,name){
		let _line = {
			name: name,
			type: 'line',
			yAxisIndex: 1,
			data: [],
			color:'#ff0000',
			label: {
				show: true,
				position: 'top',
				formatter:'{c}%',
				color:'#000'
			},
		};

		if(data.length > 0){
			_line.data = data;
		}
		return _line;
	},
	getLegend(data,pos = 'bottom',orient = 'horizontal'){

		let legend = {};

		if(data.length > 0){
			legend.data = [];
		}

		for(let i=0;i < data.length;i++){
			legend.data.push(data[i]);
		}

		if(pos === 'top'){
			legend.top = '0%';
		}else if(pos === 'left'){
			legend.left = '0%';
		}else if(pos === 'right'){
			legend.right = '0%';
			legend.top = 'middle';
		}else{
			legend.bottom = '0%';
		}

		legend.orient = orient


		return legend;
	},
}
